__webpack_require__.p = "/mailbox-fixes-next/referrals/";